export const checkOverflow = (textContainer: HTMLSpanElement | null): boolean => {
  if (textContainer) {
    return textContainer.offsetHeight < textContainer.scrollHeight;
  }
  return false;
};
